<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="resource.permiteCambiarDiagnosticador == true && resource.idEstatusSolicitud == 1">
      <b-form-select v-if="$localStorageService.can('DX_04_asignar_diagnosticador')"
                     class="parrafos"
                     size="sm parrafos"
                     v-model="data.item.idEmpleadoDiagnosticador"
                     @change="
                            putAsignarEncargadoSolicitud($event,
                              data.item.idSolicitudEtapa
                            )
                          "
      >
        <b-form-select-option
            v-for="elemento in resource.arrayDiagnosticadores"
            :key="elemento.idEmpleado"
            :value="elemento.idEmpleado"
        >{{ elemento.nombreEmpleado }}</b-form-select-option>
      </b-form-select>
    </div>
    <div v-else class="parrafos">
      <p>{{ data.item.nombreDiagnosticador }}</p>
    </div>
  </div>

</template>

<script>
    export default {
        name: "BandejaDiagnosticadorComponente",
        props: {
            data: Object,
            resource: Object
        },
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created(){
        this.debug = this.$localStorageService.getDebug();
      },
        methods: {
            putAsignarEncargadoSolicitud(idEmpleado, idSolicitudDiagnostico) {

            this.loading = true;
                var params = {
                    idEmpleado: idEmpleado,
                    idSolicitudDiagnostico: idSolicitudDiagnostico,
                    idUsuarioLogueado: this.$localStorageService.getIdUsuario()
                };

                this.$http
                    .put(this.$api + "hallazgo/bandeja/asignarEncargadoSolicitud", params)
                    .then((response) => { 
                        this.$swal.fire({
                        icon: 'success',
                        title: response.data.message
                        }); 
                    })
                    .catch((error) => {
                         this.$swal.fire({
                            icon: "error",
                            title: "Ocurrio un error",
                            text: error.message,
                        }); 
                    });

            },



            
        }
    }
</script>
